<template>
  <div class="">
    <form @submit.prevent="submit">
      <div class="container">
        <div class="row">
          <div class="col-12  ">
            <m-a :href="{name:'Sms'}">
              <button type="button" class="btn rounded-pill btn-primary ml-1 ">پیام ها</button>
            </m-a>
            <SmsCharge class="d-inline ml-1"/>
            <a href="/sms_numbers_sample.txt" download>
              <button type="button" class="btn rounded-pill btn-success ml-1 ">نمونه فایل</button>
            </a>
            <label for="choose-csv" type="button" class="btn rounded-pill btn-secondary ml-1 mb-0">وارد کردن شماره از
              فایل</label>
            <input class="d-none" id="choose-csv" type="file" @change="handleFileInputChange" accept=".txt">

            <m-a :href="{name:'SendSmsWithTemplate'}">
              <button class="btn btn-primary mr-1 rounded-pill">ارسال پیام با قالب</button>
            </m-a>


          </div>
        </div>
        <div class="row">

          <div class="col-lg-12 text-right my-2">
            <form-group :validations="$v.form.name">
              <div slot-scope="{ errors, invalid }">

                <div class="form-group">
                  <label for="exampleFormControlTextarea12">نام گروه</label>
                  <input type="text" v-model="form.name" class="form-control "
                         id="exampleFormControlTextarea12"/>
                </div>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>


          </div>

          <div class="col-lg-6 text-right my-2">
            <form-group :validations="$v.form.cellphones">
              <div slot-scope="{ errors, invalid }">

                <div class="form-group">
                  <label for="exampleFormControlTextarea1">شماره ها</label>
                  <textarea v-model="form.cellphones" class="form-control text-left" id="exampleFormControlTextarea1"
                            rows="3"></textarea>
                </div>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>


          </div>
          <div class="col-lg-6 text-right my-2">


            <form-group :validations="$v.form.raw_text">
              <div slot-scope="{ errors, invalid }">

                <div class="form-group">
                  <label for="exampleFormControlTextarea1">متن پیام</label>
                  <textarea @keyup="calculateSms" v-model="form.raw_text" class="form-control"
                            id="exampleFormControlTextarea1"
                            rows="3"></textarea>
                  <span class="mr-1 badge badge-danger"> کاراکتر {{ smsCharacter }}</span>
                  <span class="mr-1 badge badge-danger">پیام {{ smsCount }}</span>
                </div>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>

          </div>

          <div class="col text-center">
            <button ref="submit-button" type="submit" class="btn btn-primary rounded-pill px-5">ارسال پیام</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import {required} from "vuelidate/lib/validators";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import SmsCharge from "@/plugin/components/dashboard/Sms/SmsCharge.vue";
import {calculateSms, checkNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Sms";

export default {
  name: "SendSms",
  components: {SmsCharge, FormGroup, FormErrorsManager},
  data() {
    return {
      form: {
        cellphones: '',
        raw_text: '',
        name: '',
      },
      smsCount: 0,
      smsCharacter: 0,
    }
  },
  validations: {
    form: {
      cellphones: {required},
      raw_text: {required},
      name: {required},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    checkNumber,
    submit() {
      if (this.invalid()) {

        let form = {
          type: 1,
          name: this.form.name,
          raw_text: this.form.raw_text,
          items: []
        }

        let cellphone = this.form.cellphones
        cellphone = cellphone.split('\n').filter(item => item.length > 0)

        cellphone.forEach(item => {
          if (!this.checkNumber(item)) {
            toast('خطا در شماره', `شماره ${item} معتبر نیست.`, 'danger')
            throw 'number error';
          }

          form.items.push({
            number: item,
          })
        })

        this.$refs["submit-button"].disabled = true

        let req = this.$store.dispatch('Sms/sendSms', form)
        req.then(res => {
          this.$refs["submit-button"].disabled = false
          toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        })
            .catch(err => {
              this.$refs["submit-button"].disabled = false
              console.log(err)
            })

      }
    },
    calculateSms() {
      let messageLength = this.form.raw_text.length
      this.smsCharacter = messageLength
      this.smsCount = calculateSms(this.form.raw_text)
    },
    handleFileInputChange(event) {
      const file = event.target.files[0];
      if (!file) return; // No file selected

      const reader = new FileReader();
      reader.onload = () => {

        const rows = reader.result.split('\n');
        let result = rows.map(row => row.split(',')[0])
        result.forEach((item, index) => {
          if (item.length > 0) {
            let temp = item.replaceAll('\r', '');
            temp = temp[0] == 0 ? temp : `0${temp}`
            result[index] = temp.replaceAll('\r', '')
          }
        })
        this.form.cellphones = result.join('\n');

      };
      reader.onerror = error => {
        console.error('Error reading file:', error);
      };
      reader.readAsText(file);
    }

  }
}
</script>

<style scoped>

</style>